<script>
    import { sendAnalytics } from "@/core/SendAnalytics";
    import TheFormWrapper from "@main/packages/TheFormWrapper";
    import TheModalWrap from "@main/packages/TheModalWrap";
    import BaseInput from "@main/packages/BaseInput";
    import BaseTextarea from "@main/packages/BaseTextarea";

    export default {
        name: "ModalFeedback",
        components: { TheModalWrap, TheFormWrapper, BaseInput, BaseTextarea },
        data() {
            return {
                theme: "",
                msg: "",
                errorsList: {
                    name: "",
                    email: "",
                    phone: "",
                    theme: "",
                    msg: "",
                },
                isLoading: false,
                successText: "",
            };
        },
        methods: {
            send(dataFrom) {
                this.isLoading = true;

                this.$store.optionalApi
                    .sendFeedback({
                        name: dataFrom.name,
                        email: dataFrom.email,
                        phone: dataFrom.phone,
                        theme: this.theme,
                        msg: this.msg,
                    })
                    .then((response) => {
                        this.isLoading = false;
                        if (response.success) {
                            sendAnalytics.send(sendAnalytics.events.feedback);
                            this.successText = "Спасибо за заявку. Мы свяжемся с вами.";
                        } else {
                            if (Object.keys(response.errors).length > 0) {
                                Object.keys(response.errors).forEach((error) => {
                                    this.errorsList[error] = response.errors[error];
                                });
                            }
                        }
                    });
            },
            errorHandler(name) {
                this.errorsList[name] = null;
            },
        },
    };
</script>

<template>
    <the-modal-wrap title="Отправить сообщение">
        <the-form-wrapper
            title="Мы свяжемся с вами и поможем решить вопрос"
            name-button="Отправить"
            :is-loading="isLoading"
            :resulting-errors-list="errorsList"
            @submit-form="send"
            :success-text="successText"
        >
            <base-input
                v-model="theme"
                type="text"
                name="theme"
                ref="theme"
                placeholder="Тема письма"
                :error-text="errorsList.theme"
                @error="errorHandler"
            ></base-input>

            <base-textarea
                v-model="msg"
                :min-height="114"
                name="msg"
                placeholder="Ваше сообщение"
                :error-text="errorsList.msg"
                @error="errorHandler"
            ></base-textarea>
        </the-form-wrapper>
    </the-modal-wrap>
</template>

<style lang="scss"></style>
